export const isOctober = (): boolean => new Date().getMonth() === 9
